import { Component, Input, ViewEncapsulation } from '@angular/core';

import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';
import { EmailMailgunHtmlComponent } from '../email-html/email-mailgun-html.component';
import { EmailTextComponent } from '../email-text/email-text.component';

@Component({
  standalone: true,
  selector: 'email-notification',
  styleUrls: ['./email-notification.component.less'],
  template: `
    <table>
      <tr>
        <td width="36">
          <div class="avatar">
            <img class="avatar" width="36" height="36" [src]="avatar" />
          </div>
        </td>
        <td width="12">&nbsp;</td>
        <td class="web-rt-notification-body">
          <email-text
            [contents]="body"
            presetName="paragraph"
            size="small"
            className="web-rt-contains-link"
          />
        </td>
      </tr>
    </table>
  `,
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
  imports: [EmailMailgunHtmlComponent, EmailTextComponent],
})
export class EmailNotificationComponent {
  @Input() public avatar: WrappedValue<string>;
  @Input() public body: WrappedValue<string>;
}
